import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  sourceCreateFormGrid: {
    '&  .MuiCollapse-hidden': {
      display: 'none'
    }
  },
  collapsableTabGroup: {
    padding: '1.5rem',
    marginTop: '-1rem',
    border: '1px solid var(--mui-palette-divider)',
    borderBottomRightRadius: '.25rem',
    borderBottomLeftRadius: '.25rem'
  }
}));

export default useStyles;
